import { TipDetails, TipExperimentData, TipOption } from "@swiggy-private/cart-types";

export const getHeaderDetails = (
    tipMessages: TipExperimentData["tipMessages"],
): { linkName: string; imageId: string; head: string } => {
    const { imageId, linkName, head } = tipMessages;
    return {
        imageId,
        linkName,
        head,
    };
};

export const getSubtitle = (tipMessages: TipExperimentData["tipMessages"]): string => tipMessages.longMessage;

export const getCheckBoxMessage = (tipMessages: TipExperimentData["tipMessages"]): string =>
    tipMessages.checkBoxMessage;

export const getOptInBoxVisibility = (tipDetails: TipDetails): boolean => !!tipDetails.optInBoxVisibility;

export const getOptInBool = (tipDetails: TipDetails, tipExperimentData: TipExperimentData): boolean => {
    if (tipDetails.optIn == undefined) {
        return !!tipExperimentData.defaultOptIn;
    }
    return !!tipDetails.optIn;
};

export const getSelectedAmount = (tipDetails: TipDetails): number => {
    return tipDetails.amount;
};

export const isOtherAmount = (selectedAmount: number, tipOptions: TipOption[]): boolean => {
    const found = tipOptions.find(tipOption => {
        return tipOption.amount === selectedAmount;
    });

    return !found && !!selectedAmount;
};
